import React from "react";
//Image... 
import SubTitle from '../images/SubTitle.png'

export const About = () => {
    return (
        <section className='about-section' id='about'>
            <div className='section-content'>

                <div className='about-details'>
                    <h2 className='section-title'>
                        Meet Saisha
                    </h2>

                    <p className='about-text'>
                        At Saisha Spiritual Touch, I offer personalized wellness experiences designed to help you relax, restore balance, and promote overall well-being. My specialties include therapeutic massage, Reiki, sound healing, lymphatic massage, prenatal massage, hot stone therapy, and cupping therapy.

                        I also provide wellness services such as Sound Baths, Breathwork, Meditation, Spa &amp; Sports Events, Children's Workshops, Corporate Wellness Programs, and End-of-Life Doula Support.
                    </p>

                    <div className='about-stats'>
                        <div className='about-stat-card'>
                            <p className='about-stat-number'>20+</p>
                            <p className='about-stat-label'>Happy Clients</p>
                        </div>

                        <div className='about-stat-card'>
                            <p className='about-stat-number'>5+</p>
                            <p className='about-stat-label'>Years Experience</p>
                        </div>
                    </div>
                </div>

                <div className='about-image-wrapper'>
                    <img src={SubTitle} alt='Saisha performing a wellness healing session' className='about-image'/>
                </div>
            </div>
        </section>
    )
}
